export type AutoAttachDraftState =
  | {
      attach_invoice_pdfs?: boolean | null;
    }
  | null
  | undefined;

export function isAutoAttachSendBlocked(
  draft: AutoAttachDraftState,
  isLoadingInvoices: boolean,
): boolean {
  return Boolean(draft?.attach_invoice_pdfs && isLoadingInvoices);
}
